import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { IDialog } from '@shared/components/dialog/dialog.service';

export interface ConfirmDialogConfig {
  title: string;
  message: string;
  confirmText: string;
  altConfirmText?: string;
  cancelText: string;
  confirmColor: ThemePalette;
  warning?: string;
  disableClose?: boolean;
}

@Component({
  selector: 'recrewt-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent implements IDialog {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  config = inject<ConfirmDialogConfig>(MAT_DIALOG_DATA);

  form = undefined;

  constructor() {
    const dialogRef = this.dialogRef;
    const config = this.config;

    dialogRef.disableClose = config.disableClose;
  }

  noActionClicked(): void {
    this.dialogRef.close(null);
  }
}
